import { render, staticRenderFns } from "./_type.vue?vue&type=template&id=0d1af562&scoped=true"
import script from "./_type.vue?vue&type=script&lang=js"
export * from "./_type.vue?vue&type=script&lang=js"
import style0 from "./_type.vue?vue&type=style&index=0&id=0d1af562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1af562",
  null
  
)

export default component.exports